import { UsersProvider } from "./context/UsersContext";
import { UsersSurfaceCard } from "./components/UsersSurfaceCard";

export function UsersView() {
  return (
    <UsersProvider>
      <div className="h-full flex flex-col">
        <UsersSurfaceCard />
      </div>
    </UsersProvider>
  );
}

export default UsersView;
